const project_mixin = {
    methods:{
        change_screen(screen){
            this.$emit("change-screen",screen);
        }
    }
}
export {project_mixin}